import { render, staticRenderFns } from "./Practice.vue?vue&type=template&id=5633e496&scoped=true&"
import script from "./Practice.vue?vue&type=script&lang=js&"
export * from "./Practice.vue?vue&type=script&lang=js&"
import style0 from "./Practice.vue?vue&type=style&index=0&id=5633e496&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5633e496",
  null
  
)

export default component.exports